
import { Message } from 'element-ui';

export default {
  showToast(params) {
    Message.closeAll()
    Message({
      message: params.message,
      type: params.type,
      duration: params.duration || 3000
    });

  }
}



// WEBPACK FOOTER //
// ./src/utils/showToast.js